import { render, staticRenderFns } from "./TextNavigation.vue?vue&type=template&id=78b880a4&scoped=true&"
import script from "./TextNavigation.vue?vue&type=script&lang=js&"
export * from "./TextNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TextNavigation.vue?vue&type=style&index=0&id=78b880a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b880a4",
  null
  
)

export default component.exports